export default "__VITE_ASSET__a0f520ce__"